import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { startOfDay } from 'date-fns';

@Component({
  selector: 'edit-date-range-dialog',
  templateUrl: '../../shared/date-range-dialog/edit-date-range-dialog.html',
})
export class EditDateRangeDialog {
  fromDate: Date;
  toDate: Date;

  constructor(
    public dialogRef: MatDialogRef<EditDateRangeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { fromDate: Date; toDate: Date },
  ) {
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    let fromDate = startOfDay(this.fromDate);
    let toDate = startOfDay(this.toDate);
    this.dialogRef.close({ fromDate, toDate });
  }
}
